module.exports = __webpack_public_path__ + "img/mainLogo.636c7dd5.png";